export const conselhos = [
  { conselho: "Conselho Regional de Serviço Social", sigla: "CRESS" },
  { conselho: "Conselho Regional de Biologia", sigla: "CRBio" },
  { conselho: "Conselho Regional de Biomedicina", sigla: "CRBM" },
  { conselho: "Conselho Federal de Odontologia", sigla: "CFO" },
  { conselho: "Conselho Regional de Enfermagem", sigla: "COREN" },
  { conselho: "Conselho Regional de Farmácia", sigla: "CRF" },
  {
    conselho: "Conselho Regional de Fisioterapia e Terapia Ocupacional",
    sigla: "CREFITO",
  },
  { conselho: "Conselho Regional de Fonoaudiologia", sigla: "CRFa" },
  { conselho: "Conselho Regional de Medicina", sigla: "CRM" },
  { conselho: "Conselho Federal de Medicina", sigla: "CFM" },
  { conselho: "Conselho Federal de Nutricionistas", sigla: "CFN" },
  { conselho: "Conselho Federal de Educação Física", sigla: "CONFEF" },
  { conselho: "Conselho Regional de Psicologia", sigla: "CRP" },
  { conselho: "Conselho Federal de Psicologia", sigla: "CFP" },
  { conselho: "Conselho Federal de Fonoaudiologia", sigla: "CFFa" },
];

export const ufs = [
  { codigo_uf: "27", uf: "AL", unidade_federativa: "Alagoas" },
  { codigo_uf: "12", uf: "AC", unidade_federativa: "Acre" },
  { codigo_uf: "16", uf: "AP", unidade_federativa: "Amapá" },
  { codigo_uf: "13", uf: "AM", unidade_federativa: "Amazonas" },
  { codigo_uf: "29", uf: "BA", unidade_federativa: "Bahia" },
  { codigo_uf: "23", uf: "CE", unidade_federativa: "Ceará" },
  { codigo_uf: "53", uf: "DF", unidade_federativa: "Distrito Federal" },
  { codigo_uf: "32", uf: "ES", unidade_federativa: "Espírito Santo" },
  { codigo_uf: "52", uf: "GO", unidade_federativa: "Goías" },
  { codigo_uf: "21", uf: "MA", unidade_federativa: "Maranhão" },
  { codigo_uf: "51", uf: "MT", unidade_federativa: "Mato Grosso" },
  { codigo_uf: "50", uf: "MS", unidade_federativa: "Mato Grosso do Sul" },
  { codigo_uf: "31", uf: "MG", unidade_federativa: "Minas Gerais" },
  { codigo_uf: "15", uf: "PA", unidade_federativa: "Pará" },
  { codigo_uf: "25", uf: "PB", unidade_federativa: "Paraíba" },
  { codigo_uf: "41", uf: "PR", unidade_federativa: "Paraná" },
  { codigo_uf: "26", uf: "PE", unidade_federativa: "Pernambuco" },
  { codigo_uf: "22", uf: "PI", unidade_federativa: "Piauí" },
  { codigo_uf: "33", uf: "RJ", unidade_federativa: "Rio de Janeiro" },
  { codigo_uf: "24", uf: "RN", unidade_federativa: "Rio Grande do Norte" },
  { codigo_uf: "43", uf: "RS", unidade_federativa: "Rio Grande do Sul" },
  { codigo_uf: "11", uf: "RO", unidade_federativa: "Rondônia" },
  { codigo_uf: "14", uf: "RR", unidade_federativa: "Roraíma" },
  { codigo_uf: "42", uf: "SC", unidade_federativa: "Santa Catarina" },
  { codigo_uf: "35", uf: "SP", unidade_federativa: "São Paulo" },
  { codigo_uf: "28", uf: "SE", unidade_federativa: "Sergipe" },
  { codigo_uf: "17", uf: "TO", unidade_federativa: "Tocantins" },
];

export const unasus_cbo = [
  {
    cbo: 251605,
    descricao: "Assistente social",
    sinonimos: "",
  },
  {
    cbo: "2211XX",
    descricao: "Biólogos e afins",
    sinonimos: "",
  },
  {
    cbo: "2212XX",
    descricao: "Biomédicos",
    sinonimos: "",
  },
  {
    cbo: "2232XX",
    descricao: "Cirurgiões-dentistas",
    sinonimos: "",
  },
  {
    cbo: "2235XX",
    descricao: "Enfermeiros e afins",
    sinonimos: "",
  },
  {
    cbo: "2234XX",
    descricao: "Farmacêuticos",
    sinonimos: "",
  },
  {
    cbo: "2236XX",
    descricao: "Fisioterapeutas",
    sinonimos: "",
  },
  {
    cbo: "2238XX",
    descricao: "Fonoaudiólogos",
    sinonimos: "",
  },
  {
    cbo: "2251XX",
    descricao: "Médicos clínicos",
    sinonimos: "",
  },
  {
    cbo: "2252XX",
    descricao: "Médicos em especialidades cirúrgicas",
    sinonimos: "",
  },
  {
    cbo: "2253XX",
    descricao: "Médicos em medicina diagnóstica e terapêutica",
    sinonimos: "",
  },
  {
    cbo: 223305,
    descricao: "Médico veterinário",
    sinonimos: "",
  },
  {
    cbo: "2237XX",
    descricao: "Nutricionistas",
    sinonimos: "",
  },
  {
    cbo: "2241XX",
    descricao: "Profissionais da educação física",
    sinonimos: "",
  },
  {
    cbo: "2515XX",
    descricao: "Psicólogos e psicanalistas",
    sinonimos: "",
  },
  {
    cbo: "2239XX",
    descricao: "Terapeutas ocupacionais, ortoptistas e psicomotricistas",
    sinonimos: "",
  },
];

export const estadosCivil = [
  { id: "U", label: "Solteiro" },
  { id: "M", label: "Casado" },
  { id: "L", label: "Separado" },
  { id: "D", label: "Divorciado" },
  { id: "W", label: "Viúvo" },
  { id: "T", label: "Não informado" },
];

export const racas = [
  { id: "01", label: "Branca" },
  { id: "02", label: "Preta" },
  { id: "03", label: "Parda" },
  { id: "04", label: "Amarela" },
  { id: "05", label: "Indígena" },
  { id: "06", label: "Não informado" },
];

export const sexos = [
  { id: "male", label: "Maculino" },
  { id: "female", label: "Feminino" },
  { id: "unknown", label: "Ignorado" },
];
